module.exports = __webpack_public_path__ + "static/media/mail-profile.cbe4971a.svg";